exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "application-links .row-heading {\n  padding: 10px 0;\n  border-bottom: 1px solid var(--color-alto);\n  border-top: 1px solid var(--color-alto);\n}\napplication-links .link-section {\n  margin: 10px 0;\n}\napplication-links .sm-label-right {\n  padding-left: 0;\n}\napplication-links .link-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\napplication-links .link-title input {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\napplication-links .glyphicon-resize-vertical {\n  margin: 0 5px;\n  padding-top: 7px;\n  border-radius: 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/application/config/links/applicationLinks.component.less
// module id = 2822
// module chunks = 0